"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_modal_1 = __importDefault(require("react-native-modal"));
const native_1 = require("styled-components/native");
const accessibility_1 = require("../../../../shared/accessibility");
const Typography_1 = require("../../atoms/Typography/Typography");
const S = __importStar(require("./Alert.styles"));
const { height } = react_native_1.Dimensions.get('screen');
exports.Alert = ({ isVisible = true, children, modalStyle, dialogStyle, backdropColor, backdropOpacity = 0.6, useNativeDriver = true, animationIn = 'slideInUp', animationOut = 'slideOutDown', ...restProps }) => {
    const theme = native_1.useTheme();
    return (react_1.default.createElement(react_native_modal_1.default, Object.assign({}, accessibility_1.accessibilityProps('alert'), { isVisible: isVisible, backdropColor: backdropColor || theme.bpCore.colors.text, backdropOpacity: backdropOpacity, useNativeDriver: useNativeDriver, style: modalStyle, animationIn: animationIn, animationOut: animationOut, deviceHeight: height, statusBarTranslucent: true }, restProps),
        react_1.default.createElement(S.Dialog, { style: dialogStyle }, children)));
};
const Header = ({ children }) => {
    return (react_1.default.createElement(S.Header, Object.assign({}, accessibility_1.accessibilityProps('alert-header')), children));
};
const Title = ({ children }) => {
    return (react_1.default.createElement(S.Title, Object.assign({}, accessibility_1.accessibilityProps('alert-title'), { type: Typography_1.PTextType.LEAD }), children));
};
const Body = ({ hasTitle = true, children }) => {
    return (react_1.default.createElement(S.Body, Object.assign({}, accessibility_1.accessibilityProps('alert-body')),
        react_1.default.createElement(S.Content, Object.assign({}, accessibility_1.accessibilityProps('alert-content'), { type: Typography_1.PTextType.VALUE, hasTitle: hasTitle }), children)));
};
const Footer = ({ children }) => {
    return (react_1.default.createElement(S.Footer, Object.assign({}, accessibility_1.accessibilityProps('alert-footer')), children));
};
exports.Alert.Header = Header;
exports.Alert.Title = Title;
exports.Alert.Body = Body;
exports.Alert.Footer = Footer;
